$(document).on("click", ".new-cart-upsells-btn", function(){
    let arr = [];
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
    AddUpsellToCart(arr, $(this));
})
function AddUpsellToCart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        $("cart-drawer.drawer").removeClass("is-empty");
        $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
        $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          $(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

    class SessionCountdown extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.storageKey = 'session-countdown-end';
    }

    connectedCallback() {
      const durationMinutes = parseInt(this.dataset.minutes, 10) || 1;
      const durationMs = durationMinutes * 60 * 1000;

      let endTime = sessionStorage.getItem(this.storageKey);

      if (!endTime) {
        endTime = Date.now() + durationMs;
        sessionStorage.setItem(this.storageKey, endTime);
      }

      const minutesEl = this.querySelector('[data-minutes]');
      const secondsEl = this.querySelector('[data-seconds]');

      const tick = () => {
        let remaining = endTime - Date.now();

        if (remaining <= 0) {
          endTime = Date.now() + durationMs;
          sessionStorage.setItem(this.storageKey, endTime);
          remaining = durationMs;
        }

        const mins = Math.floor(remaining / 60000);
        const secs = Math.floor((remaining % 60000) / 1000);

        minutesEl.textContent = String(mins).padStart(2, '0');
        secondsEl.textContent = String(secs).padStart(2, '0');
      };

      tick();
      this.interval = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('session-countdown', SessionCountdown);



  class NewFreeShippingBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const wrapper = document.querySelector('.new-cart-bar-wrapper');
    if (!wrapper) return;
    const items = Array.from(wrapper.querySelectorAll('.new-cart-bar-tier'));
    items.sort((a, b) => {
      const orderA = parseInt(a.style.order || 0, 10);
      const orderB = parseInt(b.style.order || 0, 10);
      return orderA - orderB;
    });
    items.forEach(item => wrapper.appendChild(item));
    
    this.init(this.dataset.added, this.dataset.shouldAdd, this.dataset.id, this.dataset.added2, this.dataset.shouldAdd2, this.dataset.id2);
  }

  init(alreadyAdded, shouldAdd, vid, alreadyAdded2, shouldAdd2, vid2) {
    console.log("hehehe")
    if(shouldAdd == 'yes' && alreadyAdded == 'false'){
      let formData = new FormData();
      formData.append(`updates[${vid}]`, 1);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(function(res){
        if(res.status){
          console.log("error");
        }
        else{
          console.log('Gift added');
          const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          $("cart-drawer.drawer").removeClass("is-empty");
          $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
          $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    else if(shouldAdd == 'no' && alreadyAdded == 'true'){
      let formData = new FormData();
      formData.append(`updates[${vid}]`, 0);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(function(res){
        if(res.status){
          console.log("error");
        }
        else{
          console.log('Gift removed');
          const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          $("cart-drawer.drawer").removeClass("is-empty");
          $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
          $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    if(shouldAdd2 == 'yes' && alreadyAdded2 == 'false'){
      let formData = new FormData();
      formData.append(`updates[${vid2}]`, 1);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(function(res){
        if(res.status){
          console.log("error");
        }
        else{
          console.log('Gift 2 added');
          const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          $("cart-drawer.drawer").removeClass("is-empty");
          $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
          $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    else if(shouldAdd2 == 'no' && alreadyAdded2 == 'true'){
      let formData = new FormData();
      formData.append(`updates[${vid2}]`, 0);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(function(res){
        if(res.status){
          console.log("error");
        }
        else{
          console.log('Gift 2 removed');
          const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          $("cart-drawer.drawer").removeClass("is-empty");
          $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
          $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
}

customElements.define('new-free-shipping-bar', NewFreeShippingBar);

document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".eascStickyAddToCartBtn");
    if (!btn) return;
    if($(".custom-meta-colors-item").length > 0){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $(".custom-meta-colors-item").eq(0).trigger("click");
    }
  },
  true
);